import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd, sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const personalAdvisingStyles = css`
    :host {
        display: block;
    }

    * {
        box-sizing: border-box;
    }

    .personal-advising__wrapper {
        display: grid;
        font: var(--sbkPersonalAdvisingTypographySmallScreenBody);
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkPersonalAdvisingTypographyLargeScreenBody);
        }

        .person__container {
            margin-bottom: var(--sbkPersonalAdvisingSpacingSmallScrGap);

            @media all and (min-width: ${breakpointMd}) {
                margin-bottom: 0;
            }
        }

        @media all and (min-width: ${breakpointMd}) {
            grid-template-columns: calc(100% / 12* 5) calc(100% / 12* 7);
            padding: 0;
            grid-template-rows: minmax(0px, auto) minmax(0px, 1fr);

            .personal-advising__headline-wrapper {
                grid-column-start: 2;
                grid-column-end: span 1;
                grid-row-start: 1;
            }
            .personal-advising__introduction-wrapper {
                grid-column-start: 2;
                grid-column-end: span 1;
                grid-row-start: 2;
            }
            .personal-advising__body-wrapper {
                grid-column-start: 2;
                grid-column-end: span 1;
                grid-row-start: 3;
            }
            .person__container {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 1;
                grid-row-end: span 3;
                margin-right: calc(100% / 5);
            }
        }
    }

    .personal-advising__wrapper:not(.personal-advising__wrapper--small) {
        .personal-advising__headline-wrapper, .personal-advising__introduction-wrapper, .personal-advising__body-wrapper, .person__container {
            align-self: center;
        }
    }

    .personal-advising__wrapper--small {

        @media all and (min-width: ${breakpointMd}) {
            display: flex;
            flex-direction: column;
        }
        .personal-advising__headline-wrapper {
            padding: 0;
        }
        .personal-advising__body-wrapper {
            flex-direction: column;
        }
        .person__container {
            margin-right: 0;
        }
    }

    .personal-advising--small-image {
        @media all and (min-width: ${breakpointMd}) {
            grid-template-columns: calc(100% / 12 * 4) calc(100% / 12 * 7);
        }
        .person__container {
            margin-bottom: 0;
        }
    }

    .no-img {
        @media all and (min-width: ${breakpointMd}) {
            grid-template-columns: calc(100% / 12* 7);
            padding: 0;
            grid-template-rows: minmax(0px, auto) minmax(0px, 1fr);

            .personal-advising__headline-wrapper {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 1;
            }
            .personal-advising__introduction-wrapper {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 2;
            }
            .personal-advising__body-wrapper {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 3;
            }
        }
    }

    .personal-advising__body-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: var(--sbkPersonalAdvisingSpacingSmallScrGap);

        @media all and (min-width: ${breakpointMd}) {
            flex-direction: row;
        }
    }

    .personal-advising--reverse {
        @media all and (min-width: ${breakpointMd}) {
            grid-template-columns: calc(100% / 12* 7) calc(100% / 12* 5);
            padding: 0;
            grid-template-rows: minmax(0px, auto) minmax(0px, 1fr);

            .personal-advising__headline-wrapper {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 1;
            }
            .personal-advising__introduction-wrapper {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 2;
            }
            .personal-advising__body-wrapper {
                grid-column-start: 1;
                grid-column-end: span 1;
                grid-row-start: 3;
            }
            .person__container {
                grid-column-start: 2;
                grid-column-end: span 1;
                grid-row-start: 1;
                grid-row-end: span 3;
                margin-right: 0;
                margin-left: calc(100% / 5);
            }
            .personal-advising__job-title, .personal-advising__name {
                text-align: right;
            }
        }
    }

    .no-introduction {
        @media all and (min-width: ${breakpointMd}) {
            .personal-advising__body-wrapper {
                grid-row-start: 2;
            }
            .person__container {
                grid-row-end: span 2;
            }
        }
    }

    .personal-advising__body-button-wrapper {
        display: flex;
        flex-direction: column;
        gap: var(--sbkPersonalAdvisingSpacingSmallScrGap);

        @media all and (min-width: ${breakpointLg}) {
            gap: var(--sbkPersonalAdvisingSpacingLargeScrGapTextButton);
        }
    }

    ::slotted(img) {
        clip-path: circle(50% at 50% 50%);
        aspect-ratio: 1;
        object-fit: contain;
    }

    .person__container {
        max-width: var(--sbkPersonalAdvisingSizingViewportSmImageMaxWidth);
        @media all and (min-width: ${breakpointMd}) {
            max-width: unset;
        }
    }

    .image-container {
        position: relative;
        width: fit-content;
        height: fit-content;
        overflow: hidden;
    }

    .half-circle {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: auto;
        background: linear-gradient(180deg, var(--sbkCoreColorBlue500) 50%, transparent calc(50% + 1px));
        border-radius: 100% 100% 0 0;
        transform: rotate(200deg);
    }

    .half-circle-small {
        position: absolute;
        width: 50%;
        height: 50%;
        margin: auto;
        left: 25%;
        bottom: 25%;
        background: linear-gradient(180deg, var(--sbkCoreColorViolet500) 50%, transparent calc(50% + 1px));
        border-radius: 50% 50% 0 0;
        transform: rotate(20deg);
    }


    .personal-advising__headline-wrapper {
        padding: 0;
        max-width: var(--sbkCoreContentAreaBodyMaxWidth);
        font: var(--sbkPersonalAdvisingTypographySmallScreenHeadline);
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkPersonalAdvisingTypographyLargeScreenHeadline);
            padding: 0;
        }
        p {
            margin: 0;
        }
        margin-bottom: var(--sbkPersonalAdvisingSpacingSmallScrGap);
    }
    
    .personal-advising__introduction-wrapper slot::slotted(*) {
        margin-bottom: var(--sbkPersonalAdvisingSpacingSmallScrGap);
    }

    .personal-advising__job-title,
    .personal-advising__name {
        margin: 0;
        padding: 0;
        font: var(--sbkPersonalAdvisingTypographySmallScreenAnnotation);
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkPersonalAdvisingTypographyLargeScreenAnnotation);
        }
    }

    .personal-advising__person-info {
        margin-top: var(--sbkPersonalAdvisingSpacingSmallScrGapImageAnnotation);
        @media all and (min-width: ${breakpointLg}) {
            margin-top: var(--sbkPersonalAdvisingSpacingLargeScrGapImageAnnotation);
        }
    }
`;
